<template><!-- svgo-optimised -->
<svg class="icon icon__check" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12.5" r="12.5"/><path d="m6.818 12.5 5.114 4.546 5.682-8.523" stroke="#fff"/></svg>
</template>